<template>
	<div class="header">
		<div class="center mb-2">
			<button @click="goToHome">
				<img :src="`${$S3}logo-mibodega-white.png`" alt="logo" height="40">
			</button>
		</div>
		<p class="center text">Mi bodega, tu bodega.</p>
	</div>
</template>
<script>
export default {
	name: 'app-header',
};
</script>
<style lang="scss" scoped>
	.header {
		background: map-get($colors, title-green);
		color: map-get($colors, white);
		font-family: font(lato-regular);
		padding: 40px 0 10px 0;
	}

	.center {
		text-align: center;
	}

	.text {
		font-weight: map-get($weight, w900);
	}
</style>


// WEBPACK FOOTER //
// src/components/pago/app-header.vue